module.exports = __webpack_public_path__ + "static/media/Babys-dream-2.5c995cd9.png";